// Updated React Component
import React, { useEffect, useState, useRef } from "react"
import { motion as m } from "framer-motion"
import { requestNotificationPermission, auth } from "../../Firebase/config"
import UsefetchcollectionTime from "../Componentslogic/Usefetchcollectiontime"
import Spinner from "react-bootstrap/Spinner"
import "../../Styles/StaffDelivery.css"
import { GetoneDeliveryorderHook } from "../Componentslogic/ReservationHook/Getonedeliveryorder"
import { GetDineinorderHook } from "../Componentslogic/ReservationHook/GetsoneorderHook"
import { db, rtdb } from "../../Firebase/config"
import { ref, update, set, onChildAdded } from "firebase/database"
import { doc, setDoc, Timestamp } from "firebase/firestore"
import Notify from "../Componentslogic/Usenotifications"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { signOut } from "firebase/auth"
import {
  INCREMENT_NEW_DELIVERY_COUNT,
  RESET_NEW_DELIVERY_COUNT,
} from "../../redux/actions/OrdersStaffslice"
export const AllDeliveryOrdersStaff = () => {
  const {
    data: DeliveryorderData,
    loadMore,
    loading,
    hasMore,
    resetPaidOrders,
    resetdeliveredOrders,
  } = UsefetchcollectionTime("orders")

  const [isPermissionGranted, setIsPermissionGranted] = useState(false)
  const [
    handlePaid,
    handlePaiddetails,
    handleDelete,
    handleSeen,
    handleCheck,
    paid,
    disable,
    handleDone,
  ] = GetDineinorderHook()
  const dispatch = useDispatch()
  const [searchTerm, setSearchTerm] = useState("")
  const [showSearch, setShowSearch] = useState(false)
  const [filterType, setFilterType] = useState(() => {
    return localStorage.getItem("orderFilterType") || "pending"
  })
  const [showReset, setShowReset] = useState(false)
  const [selectedOrderType, setSelectedOrderType] = useState("dine-in")
  const newDeliveryOrders = useSelector(
    (state) => state.ordersStaff.newDeliveryOrdersCount
  )

  // 🔥 Create a reference for the search input
  const searchInputRef = useRef(null)

  const handleSearchClick = () => {
    if (showSearch) {
      setSearchTerm("")
    }
    setShowSearch((prev) => !prev)
    window.scrollTo({ top: 0, behavior: "smooth" })

    setTimeout(() => {
      if (searchInputRef.current) {
        searchInputRef.current.focus()
      }
    }, 300)
  }

  const navigate = useNavigate()

  const handleRequestPermission = async () => {
    requestNotificationPermission(process.env.REACT_APP_VAPID_KEY)
  }

  useEffect(() => {
    const deliveryOrdersRef = ref(rtdb, "DeliveryOrders")

    // Listen for new orders where ConfirmedStaff is false
    const unsubscribe = onChildAdded(deliveryOrdersRef, (snapshot) => {
      const newOrder = snapshot.val()

      // ✅ Only count orders that are NOT confirmed
      if (newOrder && !newOrder.ConfirmedStaff) {
        dispatch(INCREMENT_NEW_DELIVERY_COUNT())
      }
    })

    return () => unsubscribe() // Cleanup listener
  }, [dispatch])

  const handleOrderTypeChange = (type) => {
    setSelectedOrderType(type)

    if (type === "delivery") {
      dispatch(RESET_NEW_DELIVERY_COUNT()) // Reset new order count on click
    }
  }

  // 🔥 Function to Reset Orders & Logout User
  const handleResetAndLogout = async () => {
    try {
      await resetPaidOrders() // ✅ Reset Orders in Database
      await signOut(auth) // ✅ Sign out user from Firebase

      // ✅ Clear Session Cookie
      document.cookie =
        "session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"

      // ✅ Redirect to Login Page

      navigate("/Login")
    } catch (error) {
      console.error("Error resetting orders and logging out:", error)
    }
  }

  const handleFilterChange = (type) => {
    setFilterType(type)
    localStorage.setItem("orderFilterType", type) // Save selection
  }

  const toggleResetButton = () => {
    setShowReset((prev) => !prev)
  }

  const handleConfirmOrder = async (order) => {
    try {
      if (!order) return

      // Reference to RTDB order ID
      const orderRef = ref(rtdb, `orders/${order.id}`)

      const newOrder = {
        orderID: order.id, // Use RTDB ID as Firestore Doc ID
        userID: order.userID,
        userName: order.userName,
        userEmail: order.userEmail || "",
        phone: order.phone,
        area: order.area || "",
        orderDate: order.orderDate,
        orderTime: order.orderTime,
        totalAmount: order.totalAmount,
        cartItems: order.cartItems,
        ordernumber: order.ordernumber,
        CheckRequest: false,
        Promodiscount: order.Promodiscount || 0,
        Paid: false,
        Checked: false,
        Confirmed: true,
        PlacedAt: order.createdAt,
        createdAt: Timestamp.now().toDate(),
      }

      // Save order in Firestore using the same ID as RTDB
      const firestoreRef = doc(db, "Orders", order.id)
      await setDoc(firestoreRef, newOrder)

      // Update order in Realtime Database
      await update(orderRef, { Confirmed: true })

      Notify("Order confirmed successfully!", "success")
    } catch (error) {
      console.error("Error confirming order:", error)
    }
  }

  // Filter orders
  const filteredOrders = DeliveryorderData.filter((order) => {
    if (filterType === "pending") {
      return !order.Confirmed
    } else {
      return order.Confirmed
    }
  })

  // Search all orders
  const searchedOrders = DeliveryorderData.filter((order) =>
    order.ordernumber
      .toString()
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  )
  return (
    <div className="orders-container mt-5">
      <div className="order-type-buttons mt-5">
        <button
          className={`order-type-btn ${
            selectedOrderType === "dine-in" ? "active" : ""
          }`}
          onClick={() => handleOrderTypeChange("dine-in")}
        >
          Dine-In Orders
        </button>

        <button
          className={`order-type-btn ${
            selectedOrderType === "delivery" ? "active" : ""
          }`}
          onClick={() => {
            navigate("/staffpage/delivery")

            handleOrderTypeChange("delivery")
          }}
          style={{ position: "relative" }}
        >
          Delivery Orders
          {/* 🔴 Show badge if new delivery orders exist */}
          {newDeliveryOrders > 0 && (
            <span className="notification-badge">{newDeliveryOrders}</span>
          )}
        </button>
      </div>
      <div className="filter-buttons">
        <button
          className={`filter-btn ${filterType === "pending" ? "active" : ""}`}
          onClick={() => handleFilterChange("pending")}
        >
          Pending Orders
        </button>
        <button
          className={`filter-btn ${filterType === "confirmed" ? "active" : ""}`}
          onClick={() => handleFilterChange("confirmed")}
        >
          Confirmed Orders
        </button>
      </div>

      {/* Search Bar */}
      {showSearch && (
        <div className="search-bar-container">
          <input
            ref={searchInputRef}
            type="text"
            placeholder="Search by Order ID"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-bar-orders"
          />
        </div>
      )}
      {showReset && (
        <div className="search-bar-container">
          <button className="reset-orders-btn" onClick={handleResetAndLogout}>
            Reset Orders
          </button>
        </div>
      )}
      <div className="orders-wrapper">
        <div className="orders-list">
          {(searchTerm ? searchedOrders : filteredOrders).length > 0 ? (
            (searchTerm ? searchedOrders : filteredOrders).map(
              (item, index) => {
                return (
                  <m.div
                    className="order-card"
                    style={{ width: "370px" }}
                    key={index}
                    initial={{ opacity: 0, x: 15 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                  >
                    <div className="order-header">
                      <h3>
                        Order-ID: {item.ordernumber}{" "}
                        <span className="fw-normal"> - {item.orderTime} </span>
                      </h3>
                      <p>
                        Status:{" "}
                        {item.Confirmed && !item.Done && (
                          <span
                            className="badge-Not bg-danger"
                            onClick={() => handleDone(item.id)}
                          >
                            Preparing
                          </span>
                        )}
                        {item.Done && (
                          <span className="badge-Not  bg-primary">Done</span>
                        )}
                      </p>
                    </div>
                    <div className="horizontal-line"></div>
                    {/* Order Items */}
                    <div className="order-items">
                      <ul>
                        {item.cartItems?.map((orderItem, idx) => (
                          <li key={idx}>
                            {orderItem.CartTotalQuantity} x {orderItem.name}{" "}
                            {orderItem.selectedSize ? (
                              <span className="fw-bold">
                                {" "}
                                - {orderItem.selectedSize}{" "}
                              </span>
                            ) : null}
                            <div
                              className="d-flex justify-content-center"
                              style={{ gap: "8px" }}
                            >
                              {orderItem.spiceLevel && (
                                <div className="d-flex justify-content-center mt-2 mb-2">
                                  <div>
                                    <span className="option-square selected ">
                                      <b> Spice: </b> {orderItem.spiceLevel}
                                    </span>
                                  </div>
                                </div>
                              )}

                              {orderItem.combo && orderItem.combo.name && (
                                <div className="d-flex justify-content-center mt-2 mb-2">
                                  <span className="option-square selected p-2">
                                    <b>Combo:</b> {orderItem.combo.name} -{" "}
                                    {orderItem.combo.Price} EGP
                                  </span>
                                </div>
                              )}

                              {orderItem.freeSauce && (
                                <div className="d-flex justify-content-center mt-2 mb-2">
                                  <span className="option-square selected p-2">
                                    <b> Sauce:</b> {orderItem.freeSauce}
                                  </span>
                                </div>
                              )}
                            </div>
                            <div className="Horizontal-divider"></div>
                          </li>
                        ))}

                        <div className="d-flex justify-content-center ">
                          <p className="mt-3 p-0 m-0 ">
                            <b>Total: {item.totalAmount.toFixed(2)}</b>
                          </p>
                        </div>
                        <div className="Horizontal-divider"></div>
                        {!item.Confirmed ? (
                          <div className="d-flex justify-content-center">
                            <button
                              className="btns-Admin"
                              style={{ backgroundColor: "Green" }}
                              onClick={() => handleConfirmOrder(item)}
                            >
                              Confirm Order
                            </button>
                          </div>
                        ) : (
                          <div className="d-flex justify-content-center">
                            <span className="badge-Deliver  bg-success mb-3 ">
                              Confirmed
                            </span>
                          </div>
                        )}
                      </ul>
                    </div>
                  </m.div>
                )
              }
            )
          ) : (
            <h3>No orders available</h3>
          )}

          {loading && <Spinner animation="grow" variant="primary" />}
        </div>
      </div>

      <div className="floating-search-btn">
        <p className="reset-orders-btn" onClick={handleSearchClick}>
          {showSearch ? "Hide " : "Search"}
        </p>
        <p
          className="reset-orders-btn"
          onClick={() => {
            toggleResetButton()
            window.scrollTo({ top: 0, behavior: "smooth" }) // 🔥 Scrolls to top smoothly
          }}
        >
          {showReset ? "Hide" : "Reset"}
        </p>
      </div>
    </div>
  )
}

export default AllDeliveryOrdersStaff
